import { render, staticRenderFns } from "./inputFile.vue?vue&type=template&id=57c512e8&scoped=true&"
import script from "./inputFile.vue?vue&type=script&lang=ts&"
export * from "./inputFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c512e8",
  null
  
)

export default component.exports